var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceHolderDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 124,
    viewBox: "0 0 125 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 61.5001C124 48.1061 119.628 35.0782 111.547 24.3964C103.466 13.7146 92.1192 5.96291 79.2303 2.31934L75.0479 17.1145C84.7145 19.8472 93.2248 25.661 99.2854 33.6723C105.346 41.6837 108.625 51.4546 108.625 61.5001H124Z",
    fill: "#F1F3F5",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2303 2.31927C65.8443 -1.46485 51.5708 -0.599073 38.7402 4.77523L44.6803 18.9564C54.3032 14.9257 65.0084 14.2764 75.0479 17.1145L79.2303 2.31927Z",
    fill: "#F1F3F5",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7398 4.77542C29.5584 8.62121 21.4477 14.6382 15.1044 22.3096C8.76105 29.981 4.37464 39.0774 2.32188 48.8178C0.269123 58.5581 0.611381 68.6512 3.31925 78.2301C6.02712 87.809 11.0197 96.5874 17.8681 103.811L29.0261 93.2337C23.8898 87.8156 20.1454 81.2318 18.1145 74.0476C16.0835 66.8634 15.8268 59.2936 17.3664 51.9884C18.906 44.6831 22.1958 37.8608 26.9533 32.1072C31.7108 26.3537 37.7938 21.841 44.6798 18.9566L38.7398 4.77542Z",
    fill: "#F1F3F5",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8682 103.811C22.9269 109.147 28.9015 113.533 35.5083 116.76L42.2563 102.945C37.3011 100.525 32.8202 97.2356 29.0261 93.2335L17.8682 103.811Z",
    fill: "#F1F3F5",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5078 116.76C44.8838 121.34 55.271 123.459 65.6916 122.917C76.1123 122.376 86.2238 119.191 95.0745 113.664C103.925 108.137 111.224 100.449 116.284 91.3235C121.345 82.1979 124 71.9347 124 61.5H108.625C108.625 69.326 106.633 77.0234 102.838 83.8677C99.043 90.7119 93.5688 96.478 86.9308 100.623C80.2927 104.769 72.7091 107.157 64.8936 107.563C57.0781 107.969 49.2878 106.38 42.2557 102.945L35.5078 116.76Z",
    fill: "#F1F3F5",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceHolderDonut);
export default __webpack_public_path__ + "static/media/placeHolderDonut.6456a434c1c5eb6097bda3498a178ec9.svg";
export { ForwardRef as ReactComponent };